import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "50%",
        x2: "50%",
        y1: "100%",
        y2: "0%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#1267EF"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#0BEADE"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#a)",
      "fill-rule": "nonzero",
      d: "M12.662 2.206c1.28 0 2.338 1.103 2.338 2.382v7.633c0 1.323-1.015 2.382-2.338 2.382H2.338C1.058 14.603 0 13.5 0 12.22V4.588c0-1.28 1.059-2.382 2.338-2.382h2.47l-.66-1.191a.706.706 0 0 1 .22-.927.62.62 0 0 1 .882.265l1.059 1.809H8.47L9.529.352c.221-.352.618-.44.883-.264.309.22.397.618.22.927l-.661 1.19zm-2.206 5.647c-.177-.088-1.015-.574-2.162-1.191C7.676 6.309 7.103 6 7.06 5.956c-.133-.088-.265-.088-.397-.088-.441 0-.794.397-.794.838V10.5a.79.79 0 0 0 .794.794.7.7 0 0 0 .397-.132c.088-.044.662-.397 1.323-.706 1.192-.662 1.986-1.147 2.118-1.191a.84.84 0 0 0 .397-.706 1 1 0 0 0-.441-.706"
    }, null, -1)
  ])))
}
export default { render: render }